enum RequestOutcome {
    NOT_REVIEWED = -1,
    REJECTED = 0,
    ACCEPTED = 1
}

export default RequestOutcome;